// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__1M2bC","videoWrapper":"style_videoWrapper__QFkOv","video":"style_video__2uz1h"};